import React, { FunctionComponent } from "react";
import { Wordmark } from "../../wordmark";

export interface Footer {
  copyrightOwner: string;
  links: { label: string; href: string }[];
}

export const Footer: FunctionComponent<Footer> = ({
  copyrightOwner,
  links,
}) => (
  <footer className="flex flex-col gap-4 bg-ink px-gutter-sm py-10 font-display text-paper-2 md:flex-row md:items-center md:justify-between md:px-gutter">
    <Wordmark size="compact" className="tracking-[-0.04em]" />
    <div className="flex flex-wrap items-center gap-6 text-ui font-semibold">
      {links.map(({ label, href }) => (
        <a
          key={href}
          href={href}
          className="text-paper-2 transition-colors duration-maker ease-maker hover:text-spark"
        >
          {label}
        </a>
      ))}
      <span className="font-normal text-[#8a8a8a]">
        © {new Date().getFullYear()} {copyrightOwner}
      </span>
    </div>
  </footer>
);
